var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [true ? _c('Header', {
    attrs: {
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section'),
      "meta": _vm.meta
    }
  }) : _vm._e(), _c('router-view')], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }